"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = quickly_convert_rgba_to_rgb;
var _isHidden = _interopRequireDefault(require("../is-hidden"));
var _popAlpha = _interopRequireDefault(require("../pop-alpha"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function quickly_convert_rgba_to_rgb(noDataPixel, pixel) {
  return (0, _isHidden.default)(pixel) ? noDataPixel : (0, _popAlpha.default)(pixel);
}